
const UserRealData = {
    user: {},
    realEvents: [],
    realRecurrent: [],
    realTeams: [],
    realEarnings: [],
}

export default UserRealData;